import { useState } from 'react';
import React from 'react';

import { Table, Tr, Td, Text, Tbody, Collapse, Box, Link, Icon, useColorModeValue } from '@ecoinvent/ui';
import { BiCommentDetail } from 'react-icons/bi';

import { FlowDetails } from 'hooks/data/datasets/V4/flows/types';

type Props = {
  classification: FlowDetails['classification'];
};

const ClassificationTable = ({ classification }: Props) => {
  const [expandedComments, setExpandedComments] = useState<number[]>([]);

  const toggleComment = (index: number) => {
    if (expandedComments.includes(index)) {
      setExpandedComments(expandedComments.filter((i) => i !== index));
    } else {
      setExpandedComments([...expandedComments, index]);
    }
  };

  const isExpanded = (index: number) => expandedComments.includes(index);
  const bg = useColorModeValue('gray.100', 'gray.900');
  const tablesBg = useColorModeValue('white', 'gray.800');
  const commentColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Table variant="unstyled" sx={{ tableLayout: 'fixed', width: '100%' }}>
      <Tbody>
        {Object.keys(classification).map((key, index) => {
          const value = classification[key as keyof typeof classification]?.value;
          const comment = classification[key as keyof typeof classification]?.comment;

          return (
            <React.Fragment key={key}>
              <Tr bg={isExpanded(index) ? bg : undefined} sx={isExpanded(index) ? { td: { borderBottom: 'none' } } : undefined}>
                <Td py={4} px={4} w="15%">
                  <Text fontWeight="semibold">{key}</Text>
                </Td>
                <Td py={4} px={4} w="70%">
                  <Text>{value || 'N/A'}</Text>
                </Td>
                <Td py={4} px={4} w="15%" textAlign="right">
                  {comment && (
                    <Link
                      display="flex"
                      justifyContent="flex-end"
                      alignItems="center"
                      cursor="pointer"
                      fontSize="sm"
                      onClick={() => toggleComment(index)}
                    >
                      <Icon as={BiCommentDetail} mr={2} /> Comment
                    </Link>
                  )}
                </Td>
              </Tr>
              <Tr key={`${key}-comment`}>
                <Td
                  px={4}
                  pb={isExpanded(index) ? 4 : 0}
                  pt={0}
                  colSpan={3}
                  border={isExpanded(index) ? 'auto' : 'none'}
                  bg={isExpanded(index) ? bg : undefined}
                >
                  {comment && (
                    <Collapse in={isExpanded(index)} unmountOnExit>
                      <Box p={isExpanded(index) ? 4 : 0} bg={tablesBg}>
                        <Text fontSize="sm" whiteSpace="pre-wrap" color={commentColor}>
                          {comment}
                        </Text>
                      </Box>
                    </Collapse>
                  )}
                </Td>
              </Tr>
            </React.Fragment>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default ClassificationTable;
